import type { KeyboardEvent } from 'react'
import type { MarkdownActions } from '../MarkdownEditorState/actions'

export const handleMarkdownEditorKeyDown = (
  e: KeyboardEvent<HTMLTextAreaElement>,
  actions: MarkdownActions,
): boolean => {
  if (handleTab(e, actions)) return true
  if (handleShiftEnterInList(e, actions)) return true
  if (handleEnterInList(e, actions)) return true
  return false
}

export const handleTab = (
  e: KeyboardEvent<HTMLTextAreaElement>,
  actions: MarkdownActions,
): boolean => {
  if (e.key !== 'Tab') return false

  e.shiftKey ? actions.unindent() : actions.indent()

  e.preventDefault()
  return true
}

export const handleEnterInList = (
  e: KeyboardEvent<HTMLTextAreaElement>,
  actions: MarkdownActions,
): boolean => {
  if (e.key !== 'Enter') return false

  const applicableActions = [
    actions.clearListItem,
    actions.newListItem,
    actions.continueListItem,
    actions.newQuoteLine,
  ]

  for (const action of applicableActions) {
    const applied = action()
    if (applied) {
      e.preventDefault()
      return true
    }
  }

  return false
}

export const handleShiftEnterInList = (
  e: KeyboardEvent<HTMLTextAreaElement>,
  actions: MarkdownActions,
): boolean => {
  if (e.key !== 'Enter' || !e.shiftKey) return false

  const applied = actions.continueListItem({ requireBackslash: false })
  if (!applied) return false

  e.preventDefault()
  return true
}
